import Experiments from '@wix/wix-experiments'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { shouldUseSeoV2RouteConfig } from './useSeoV2Infra'

export const ensurePageIsLegacyIndexable = async ({
  editorSdkProxy,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
}): Promise<void> => {
  const appApi = await editorSdkProxy.editor.getAppAPI()
  const experiments = await appApi.getAllExperiments()
  const useSeoV2RouteConfig = await shouldUseSeoV2RouteConfig({
    editorSdkProxy,
    experimentsManager: new Experiments({
      experiments,
    }),
  })
  if (!useSeoV2RouteConfig) {
    return
  }

  await editorSdkProxy.document.pages.data.update({
    pageRef,
    data: {
      indexable: true,
    },
  })
}
